import React from "react";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import Typography from '@mui/material/Typography';

import * as SelectTypes from '../constants/CustomSelectTypes'
import * as SelectListData from '../constants/CustomSelectData'


function getSelectDataByType(selectType) {
    switch(selectType) {
        case SelectTypes.JUDETE:
            return {dataArray: SelectListData.judeteArray, label: "Judet"};
        case SelectTypes.EMPLOYER_TYPE:
            return {dataArray: SelectListData.employerTypeArray, label: "Tip Angajator"};
        case SelectTypes.FORMA_JURIDICA:
            return {dataArray: SelectListData.formaJuridicaArray, label: "Forma Juridica"};
        case SelectTypes.PROPERTY_TYPE:
            return {dataArray: SelectListData.propertyTypeArray, label: "Forma Proprietate"};
        case SelectTypes.EMPLOYER_SIZE:
            return {dataArray: SelectListData.employerSizeArray, label: "Dimensiunea Intreprinderii"};
        case SelectTypes.SEX_TYPE:
            return {dataArray: SelectListData.sexType, label: "Sex"};
        case SelectTypes.STARE_CIVILA:
            return {dataArray: SelectListData.stareCivila, label: "Stare Civila"};
        case SelectTypes.PERSOANE_INTRETINERE:
            return {dataArray: SelectListData.persoaneIntretinere, label: "Persoane in Intretinere"};
        case SelectTypes.CETATENIE:
            return {dataArray: SelectListData.cetatenie, label: "Cetatenie"};
        case SelectTypes.STATUT_PROFESIONAL:
            return {dataArray: SelectListData.statutProfesional, label: "Statut Profesional"};
        case SelectTypes.DURATA_MUNCII:
            return {dataArray: SelectListData.durataMuncii, label: "Durata Muncii"};
        case SelectTypes.ANGAJAT_AUTORIZAT_ISCIR:
            return {dataArray: SelectListData.angajatAutorizatIscirShort, label: "Angajat Autorizat ISCIR"};
        case SelectTypes.ANGAJAT_AUTORIZAT_INTERN:
            return {dataArray: SelectListData.angajatAutorizatIntern, label: "Angajat Autorizat Intern"};    
        case SelectTypes.ANGAJAT_AUTORIZAT_TYPES:
            return {dataArray: SelectListData.angajatAutorizatTypes, label: "Tip Autorizatie"};    
        case SelectTypes.CLIENT_TYPE:
            return {dataArray: SelectListData.clientTypeOptions, label: "Tipul Client"};
        case SelectTypes.CLIENT_SERVICE_TYPE:
            return {dataArray: SelectListData.clientServiceTypeOptions, label: "Tipul Serviciului"};
        case SelectTypes.SYSTEM_USER_ROLES:
            return {dataArray: SelectListData.roleSystem, label: "Rol Utilizator System"};
        case SelectTypes.CLIENT_USER_ROLES:
            return {dataArray: SelectListData.roleClient, label: "Rol Utilizator Client"};
        case SelectTypes.TASK_STATUS:
            return {dataArray: SelectListData.taskStatus, label: "Task Status"};
        case SelectTypes.EMPLOYEE_CONTRACT_STATUS:
            return {dataArray: SelectListData.employeeContractStatus, label: "CIM Status"};
        case SelectTypes.AUTHORIZATION_STATUS:
            return {dataArray: SelectListData.authorizationStatusOptions, label: "Autorizatie Status"};
        case SelectTypes.COURSE_REGISTRATION_STATUS:
            return {dataArray: SelectListData.courseRegistrationOptions, label: "Status Curs"};
        case SelectTypes.INSTALATII_PERSONAL_AUXILIAR:
            return {dataArray: SelectListData.instalatiiPersonalAuxiliar, label: "Tip Instalatie Deservita"};
                                
        default:
            console.log('Unknown select value type: ' + selectType);
            return [];
    }
}

const getSelectData = (props) => {
    if(props.selectType)
        return getSelectDataByType(props.selectType);
    else if(props.selectData) {
        return props.selectData;
    }
    else {
        console.log("No SelectData or SelectType provided");
        return [];
    }

}

function CustomSelect(props){
    const [defaultValue, setDefaultValueMethod] = React.useState( !!props.value ? props.value : '');

    //On the change event for the select box pass the selected value back to the parent
    const handleChange = (event) =>
    {
        let selectedValue = event.target.value;
        setDefaultValueMethod(selectedValue);
        if(props.callback != null) {
            props.callback(selectedValue)
        }
    }

    const selectData = getSelectData(props);
    var itemLabel = props.label ? props.label : selectData.label;

    return (
        <React.Fragment>
            <FormControl fullWidth size="small" margin="dense" variant="standard">
                <InputLabel id={props.selectId + '-inputLabelId'} error={props.error}>{itemLabel}</InputLabel>
                <Select
                    {...props.register}
                    labelId={props.selectId + '-selectLabelId'}
                    id={props.selectId}
                    disabled={!!props.disabled ? props.disabled : false}
                    value={defaultValue}
                    onChange={handleChange}
                    label={props.selectId + '-label'}
                    error={props.error}
                    >
                    {
                        selectData.dataArray.map((data) => <MenuItem dense value={data.id} key={data.id}> {data.name} </MenuItem>)
                    }
                </Select>
                <Typography sx={{ color: 'error.main', fontSize: 12 }}>{props.helperText}</Typography>
                
            </FormControl>
        </React.Fragment>
    );
}

export default CustomSelect;